import Link from "next/link"
import { Suspense } from "react"
import { CategorySelect } from "@/components/shared/header/category-select"
import { CartSheet } from "@/components/shared/header/navbar-components/cart-sheet"
import { Logo } from "@/components/shared/header/navbar-components/logo"
import UserMenu from "@/components/shared/header/navbar-components/user-menu"
import { StickyHeader } from "~/components/shared/header/sticky-header"
import { SearchProducts } from "./search-products"

export function Header() {
  return (
    <>
      <header
        className='flex w-full flex-col items-center justify-center border-2 border-b bg-white px-4 md:px-8'
        id='site-header'
      >
        <div className='flex h-26 w-full max-w-6xl items-center justify-between gap-4'>
          <div className='flex flex-1 items-center gap-2'>
            <div className='flex items-center'>
              <Link className='text-primary hover:text-primary/90' href='/'>
                <Logo />
              </Link>
            </div>
          </div>

          <div className='hidden w-full max-w-150 md:flex md:justify-center'>
            <SearchProducts />
          </div>

          <div className='flex flex-1 items-center justify-end gap-2'>
            <CartSheet />
            <UserMenu />
          </div>
        </div>

        <hr className='hidden w-full md:block' />

        <div className='hidden w-full max-w-6xl py-2 md:block'>
          <Suspense
            fallback={<div className='h-10 w-full rounded-md border' />}
          >
            <CategorySelect />
          </Suspense>
        </div>
      </header>

      <StickyHeader />
    </>
  )
}
